<template>
  <div id="app">
    <section id="team" class="team">
      <div class="team-decor">
        <div class="team-circle1"><img :src='"../assets/images/team1.png"' alt=""></div>
        <div class="team-circle2"><img :src='"../assets/images/team3.png"' alt=""></div>
        <div class="team-circle3"><img :src='"../assets/images/team.png"' alt=""></div>
      </div>
      <div class="container">
        <div class="row ">
          <div class="col-sm-12">
            <h2 class="title">In the <span>News</span></h2>
          </div>
          <div class="col-sm-12">
            <div>
                  <div class="row">
                    <div class="col-lg-8 mx-auto">                      
                      <div :key="article.url" v-for="article in articles" class="press-row row col-sm press-article">
                          <a :href="article.url">
                                <div class="press-image-container">
                                 <img :src='getImgUrl(article.imageUrl)' alt="">
                                </div>
                                <div>{{article.text}}</div>
                          </a>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  name: 'Team',
  methods: {
    getImgUrl(name) {
        var images = require.context('../assets/images/presslogo', false, /\.png$/)
        return images('./' + name + ".png")
    }
  },
  data() {
    return {
      articles: [
        {
          url: "https://developer.amazon.com/blogs/alexa/post/1c5f9c52-9222-4669-81be-c091c9c9c151/gal-shenar-has-cracked-the-code-when-it-comes-to-earning-alexa-developer-rewards",
          text: "Gal Shenar Has “Cracked the Code” When It Comes to Earning Alexa Developer Rewards",
          imageUrl: "amazon"
        },
        {
          url: "https://www.cnet.com/news/how-close-is-alexas-escape-the-room-to-an-actual-escape-room/",
          text: "How close is Alexa's Escape the Room game to an actual escape room?",
          imageUrl: "cnet"
        },
        {
            url: "https://techcrunch.com/2019/05/01/alexa-in-skill-purchasing-which-lets-developers-make-money-from-voice-apps-launches-internationally/",
            text: "Alexa in-skill purchasing, which lets developers make money from voice apps, launches internationally",
            imageUrl: "tc"
        },
        {
          url: "https://www.dashbot.io/2018/06/06/how-this-alexa-skill-developer-increased-retention-of-voice-game-by-15/",
          text: "How this Alexa Skill Developer Increased Retention of Voice Game by 15%",
          imageUrl: "dashbot"
        },
        {
          url: "https://www.homeandsmart.de/alexa-skill-dschungelgeraeusche",
          text: "Alexa Dschungelgeräusche Skill zum Einschlafen und Entspannen",
          imageUrl: "homesmart"
        },
        {
          url: "https://developer.amazon.com/blogs/alexa/post/1200d647-8ed9-4389-b07a-1a19eb79e9ce/conversation-with-stoked-skills-gal-shenar-how-to-build-captivating-voice-first-games-for-alexa",
          text: "Conversation with Stoked Skills’ Gal Shenar: How to Build Captivating Voice-First Games for Alexa",
          imageUrl: "amazon"
        },
        {
          url: "https://www.jargon.com/blog/2019/05/jargon-takes-escape-the-room-to-germany/",
          text: "Jargon takes Escape the Room to Germany",
          imageUrl: "jargon"
        },
        {
          url: "https://www.jovo.tech/stories/escape-the-room-stoked-skills",
          text: "Why I migrated my Alexa Skill with 1700+ reviews to Jovo",
          imageUrl: "jovo"
        },

      ]
    }
  }
}
</script>

<style>
    @media (max-width: 768px) {
        .press-article img {
    width: 100% !important;
    }
    }
  .press-article img {
    width: 75%;
  }
  .press-row {
      align-items: center;
      margin: 15px 0px;
      height: 70px;
  }
  .press-article a {
      width: 100%;
      display: grid;
      grid-template-columns: 20% 80%;
      grid-column-gap: 20px;
      align-items: center;
   }
    .press-image-container {
        text-align: center;
    }
  .cnet-link {
      font-size: 30px;
      color: red;
      font-weight: bold;
      margin-top: 50px;
      display: inline-block;
  }
</style>


// WEBPACK FOOTER //
// src/components/Team.vue